const OrdersManagementConstantsEn = {
  orderListMainTitle: 'Orders Management',
  orderAllStatus: 'All',
  orderPendingStatus: 'Pending',
  orderPaidStatus: 'Paid',
  orderFailedPaymentStatus: 'Failed payment',
  orderDeliveredStatus: 'Delivered',
  orderCancelledStatus: 'Cancelled',
  totalOrders: 'Orders',
  totalMedia:'Media',
  orderTableOrderIdColumn: 'Order Id',
  orderTableOrderCountColumn: 'Media Count',
  orderTableDateColumn: 'Date',
  orderTableUserNameColumn: 'User Name',
  orderTableStatusColumn: 'Status',
  orderDetailsMainTitle: 'View Order',
  orderDetailsStatusSection: 'Order Status',
  orderDetailsDeliveryDate: 'Estimate delivery date',
  orderDetailsUserDetailsSection: 'User Details',
  orderDetailsUserDetailsFirstName: 'First Name',
  orderDetailsUserDetailsLastName: 'Last Name',
  orderDetailsUserDetailsEmail: 'Email',
  orderDetailsUserDetailsCompanyName: 'Company Name',
  orderDetailsPaymentMethodSection: 'Payment Method',
  orderDetailsCreditCard: 'Credit Card',
  orderDetailsWireTransfer: 'Wire Transfer',
  orderDetailsVideosDetailsSection: 'Videos Details',
  orderDetailsUpdateButtonText: 'Update Order',

  orderDetailsDialogTableRightColumn: 'Rights',
  orderDetailsDialogTableExclusivityColumn: 'Exclusivity',
  orderDetailsDialogTableHoldbackColumn: 'Holdback',
  orderDetailsDialogTableOneMonthOption: '1 Month',
  orderDetailsDialogTableThreeMonthOption: '3 Month',
  orderDetailsDialogTableSixMonthOption: '6 Month',
  orderDetailsDialogTableNineMonthOption: '9 Month',
  orderDetailsDialogOnlineDeliveryMethod: 'Online',
  orderDetailsDialogOtherDeliveryMethod: 'Other',
  orderDetailsDialogCountries: 'Countries',
  orderDetailsDialogLicensePeriod: 'License Period',
  orderDetailsDialogDeliveryMethod: 'Delivery Method',
  orderDetailsDialogDeliveryDate: 'Delivery Date',
  orderDetailsDialogChannels: 'Channels',
  orderDetailsDialogNotes: 'Notes',
  orderDetailsDialogTableExclusiveColumn: 'Exclusive',
  orderDetailsDialogTableNonExclusiveColumn: 'Non Exclusive',
  orderDetailsUpdatedSuccessfully: 'Order Updated Successfully',
  orderDetailsTotalPrice: 'Total Price',
  pickDate: 'Pick Date',
  orderPreparationStatus:'Preparing'
};
export default OrdersManagementConstantsEn;
